import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Bar,
  BarChart,
  Brush,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import {
  labelFormatterBillions,
  labelFormatterMoneyAsFloat,
  labelFormatterNumber,
} from '../../../../../shared/formatters/formatters';
import { ReleasesRealEstateFinancingChartData } from './types';

export const ReleasesRealEstateFinancing: React.FC = () => {
  const { requesStatusMarketCycle, chartsDataMarketCycle } = useSelector(
    (state: any) => state.marketCycleState
  );

  return (
    <ChartCard
      data={chartsDataMarketCycle['releasesRealEstateFinancing']}
      Chart={ReleasesRealEstateFinancingChart}
      cy={'ReleasesRealEstateFinancing'}
      id={'releasesRealEstateFinancing'}
      requestStatus={requesStatusMarketCycle['releasesRealEstateFinancing']}
    />
  );
};

const ReleasesRealEstateFinancingChart: React.FC<
  IChartProps<ReleasesRealEstateFinancingChartData[]>
> = ({ data, cy, id }) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [labelFormatterNumber, labelFormatterBillions];
  return (
    <ResponsiveContainer data-cy={`MarketPriceINCC${cy}`}>
      <BarChart
        id={id}
        data={data}
        margin={{
          top: 30,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <Legend iconType="circle" />
        <XAxis
          dataKey="period"
          padding={{ left: 30, right: 30 }}
          domain={['auto', 'dataMax']}
        />
        <YAxis
          yAxisId="releases"
          orientation="left"
          tickFormatter={labelFormatterNumber}
          label={{
            value: nls.charts.releasesRealEstateFinancing.releases,
            position: 'top',
            offset: 15,
          }}
        ></YAxis>
        <YAxis
          yAxisId="realEstateFinancing"
          orientation="right"
          label={{
            value: nls.charts.releasesRealEstateFinancing.realEstateFinancing,
            position: 'top',
            offset: 15,
          }}
          tickFormatter={(value: number) =>
            `${labelFormatterMoneyAsFloat(value)}bi`
          }
        />
        <Bar
          yAxisId="releases"
          dataKey="unidades_lancadas"
          fill="#BA96D9"
          isAnimationActive={false}
          name={nls.charts.releasesRealEstateFinancing.releases}
        >
          <LabelList
            dataKey="unidades_lancadas"
            position="top"
            fill="#000"
            formatter={labelFormatterNumber}
          />
        </Bar>
        <Bar
          dataKey="valor_financiamento"
          fill="#793EAD"
          isAnimationActive={false}
          name={nls.charts.releasesRealEstateFinancing.realEstateFinancing}
          yAxisId="realEstateFinancing"
        >
          <LabelList
            dataKey="valor_financiamento"
            position="top"
            fill="#000"
            formatter={(value: string | number) =>
              value.toString().replaceAll('.', ',')
            }
          />
        </Bar>
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};
